// extracted by mini-css-extract-plugin
export default {"section":"Tabs_section__cBFCl","tabs":"Tabs_tabs__JLp-Q","tab":"Tabs_tab__EYla9","tabActive":"Tabs_tabActive__PkM8s","btn":"Tabs_btn__hyDka","loading":"Tabs_loading__p-tqC"};